import { render, staticRenderFns } from "./ViewMobileSubscriptions.vue?vue&type=template&id=2cfd2cd4&scoped=true"
import script from "./ViewMobileSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./ViewMobileSubscriptions.vue?vue&type=script&charset=utf-8&lang=js"
import style0 from "./ViewMobileSubscriptions.vue?vue&type=style&index=0&id=2cfd2cd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfd2cd4",
  null
  
)

export default component.exports